const pixelFonts = [
  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 23, 24, 28, 32, 33, 40, 48, 56,
  72,
];
const fontSize = pixelFonts.reduce(
  (obj, val) => ({
    ...obj,
    [`${val}`]: `${val / 16}rem`,
  }),
  {}
);

const spacingSizes = [
  0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30,
];
const spacing = spacingSizes.reduce((acc, val) => {
  acc[`${val}`] = `${val / 4}rem`;
  return acc;
}, {});

const timingDurations = {
  0: '0',
  lazy: '640ms',
  light: '440ms',
  ridiculous: '240ms',
  ludicrous: '160ms',
};

const extendedPalette = {
  geyser: '#CDE0DF',
  tuberose: '#F7F2DC',
  gingerrr: '#FFAA00',
  rose: '#E25959',
  tangerine: '#BF4228',
  maroon: '#680021',
  puce: '#7E245C',
  inevitable: '#481D72',
  virginia: '#002855',
  mosaic: '#006880',
  eastern: '#1991A9',
  caribbean: '#16A7A7',
  evergreen: '#004851',
  // nectar branding
  premium: '#EEDDBD',
};

const primaryColors = {
  900: '#0E0722',
  800: '#1A0C37',
  700: '#28104C',
  600: '#3A1561',
  500: '#4E1976',
  400: '#8326B5',
  300: '#B44EDA',
  200: '#F68EE7',
  100: '#F0CDF4',
  50: '#FAF5FD',
};

const secondaryColors = {
  900: '#001B1B',
  800: '#003F3E',
  700: '#006361',
  600: '#008685',
  500: '#00AAA8',
  400: '#00D6D4',
  300: '#3AFFFD',
  200: '#81FFFE',
  100: '#C5FAF9',
  50: '#EAFFFF',
};

const warningColors = {
  900: '#1E0F00',
  800: '#562D00',
  700: '#8E4A00',
  600: '#C66700',
  500: '#FE8400',
  400: '#FF9F37',
  300: '#FFBA6F',
  200: '#FFDA7',
  100: '#FFF0DF',
  50: '#FFFDFB',
};
const errorColors = {
  900: '#1E0009',
  800: '#460015',
  700: '#6F0121',
  600: '#97012E',
  500: '#C0013A',
  400: '#FE0650',
  300: '#FE487E',
  200: '#FE8AAC',
  100: '#FFCBDB',
  50: '#FFECF2',
};

const baseColors = {
  900: '#14142b',
  800: '#262338',
  700: '#4e4b66',
  600: '#6e7191',
  500: '#A0A3bd',
  400: '#d9dbe9',
  300: '#Eff0f7',
  200: '#f7f7fc',
  100: '#fcfcfc',
};

module.exports.extendedPalette = extendedPalette;

module.exports.default = {
  backgroundImage: {
    // Gradient Background Colors
    'purple-gradient': 'linear-gradient(103.15deg, #6B4392 0%, #3D1266 100%)',
    'secondary-gradient':
      'linear-gradient(103.15deg, #26D0D0 0%, #16A7A7 100%)',
    'gray-gradient':
      'linear-gradient(90deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.2) 48.55%, rgba(255, 255, 255, 0.1) 100%)',
  },
  boxShadow: {
    1: '0px 1px 2px rgba(0, 0, 0, 0.12)',
    2: '0px 1px 2px rgba(0, 0, 0, 0.07), 0px 2px 4px rgba(0, 0, 0, 0.07)',
    3: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.06)',
    4: '0px 1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 4px 8px rgba(0, 0, 0, 0.05), 0px 8px 16px rgba(0, 0, 0, 0.05)',
    5: '0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04)',
    6: '0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04), 0px 32px 64px rgba(0, 0, 0, 0.04)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    outline: '0 0 0 2px rgba(72, 29, 114, 0.5)',
    'outline-secondary': '0 0 0 2px #91E7E7',
    'outline-tertiary': '0 0 0 2px #e35b76',
    'outline-gray': '0 0 0 2px #C2C2C2',
    none: 'none',
  },
  colors: {
    // Base
    primary: {
      strong: primaryColors[800],
      700: primaryColors[700],
      600: primaryColors[600],
      default: primaryColors[500],
      light: primaryColors[400],
      300: primaryColors[300],
      200: primaryColors[200],
      lighter: primaryColors[100],
      weak: primaryColors[50],
    },

    secondary: {
      strong: secondaryColors[800],
      700: secondaryColors[700],
      600: secondaryColors[600],
      default: secondaryColors[500],
      light: secondaryColors[400],
      300: secondaryColors[300],
      200: secondaryColors[200],
      lighter: secondaryColors[100],
      weak: secondaryColors[50],
    },
    success: {
      strong: secondaryColors[800],
      700: secondaryColors[700],
      600: secondaryColors[600],
      default: secondaryColors[500],
      light: secondaryColors[400],
      300: secondaryColors[300],
      200: secondaryColors[200],
      lighter: secondaryColors[100],
      weak: secondaryColors[50],
    },

    warning: {
      strong: warningColors[800],
      700: warningColors[700],
      600: warningColors[600],
      default: warningColors[500],
      light: warningColors[400],
      300: warningColors[300],
      200: warningColors[200],
      lighter: warningColors[100],
      weak: warningColors[50],
    },
    error: {
      strong: errorColors[800],
      700: errorColors[700],
      600: errorColors[600],
      default: errorColors[500],
      light: errorColors[400],
      300: errorColors[300],
      200: errorColors[200],
      lighter: errorColors[100],
      weak: errorColors[50],
    },

    // Grayscale
    black: '#121212',
    base: {
      ...baseColors,
    },
    white: '#fff',
    transparent: 'transparent',

    // Semantic accents
    info: '#0988B0',
    'info-light': '#EFF9FC',

    // Extended palette
    ...extendedPalette,

    // Third-party brand colors
    intercom: '#276EFA',
    facebook: '#3B5998',
    twitter: '#1DA1F2',
    google: '#4285F4',
    linkedin: '#0077B5',
    trustpilot: '#007F4E',
    youtube: '#FF0000',
  },
  fontFamily: {
    sans: "'proxima-nova', 'proxima-soft', 'system-ui', sans-serif",
    serif: "'p22-mackinac-pro', serif",
    poppins: 'Poppins',
    'proxima-nova': 'Proxima Nova',
  },
  fontSize,
  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    'extra-bold': '800',
  },
  inset: {
    '1/2': '50%',
  },

  letterSpacing: {
    tight: '-0.025em', // -0.5px
    normal: '0', // 0px
    'semi-wide': '0.006em', // 0.1px
    wide: '0.01em', // 0.2px
    extended: '0.013em', // 0.25px
    wider: '0.075em', // 1.5px
    widest: '0.1em', // 2px
    roomy: '0.188em', // 3px
  },
  lineHeight: {
    5: '1.25rem', // 20px
    none: '1',
    tight: '1.125',
    normal: '1.5',
    loose: '2',
    sm: {
      0: '0.75rem', // 12px
      1: '1rem', // 16px
      2: '1.25rem', // 20px
    },
    md: {
      0: '1.375rem', // 22px
      1: '1.5rem', // 24px
      2: '1.75rem', // 28px
    },
    lg: {
      0: '2rem', // 32px
      1: '2.25rem', // 36px
      2: '2.5rem', // 40px
      3: '2.75rem', // 44px
    },
    xl: {
      0: '3rem', // 48px
      1: '3.5rem', // 56px
      2: '4rem', // 64px
      3: '4.5rem', // 72px
    },
  },
  opacity: {
    0: '0',
    10: '.1',
    20: '.2',
    30: '.3',
    40: '.4',
    50: '.5',
    60: '.6',
    70: '.7',
    80: '.8',
    90: '.9',
    100: '1',
  },
  screens: {
    xs: '30rem', // xs: '480px',
    sm: '40rem', // sm: '640px',
    md: '48rem', // md: '768px',
    lg: '64rem', // lg: '1024px',
    xl: '80rem', // xl: '1280px',
    '2xl': '90rem', // '2xl': '1440px',
  },
  ...spacing,
  container: {
    xs: '30rem', // xs: '480px',
    sm: '40rem', // sm: '640px',
    md: '48rem', // md: '768px',
    lg: '64rem', // lg: '1024px',
    xl: '80rem', // xl: '1280px',
    '2xl': '90rem', // '2xl': '1440px',
  },
  transitionDelay: timingDurations,
  transitionDuration: timingDurations,
  transitionTimingFunction: {
    linear: 'linear',
    out: 'cubic-bezier(0, 0.55, 0.45, 1)',
    in: 'cubic-bezier(0.55, 0, 1, 0.45)',
    'in-out': 'cubic-bezier(0.85, 0, 0.15, 1)',
  },
};
